// PWA display mode detection
export function getPWADisplayMode() {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  if (document.referrer.startsWith('android-app://')) {
    return 'twa';
  } else if (navigator.standalone || isStandalone) {
    return 'standalone';
  }
  return 'browser';
}

// iOS detection
export function isIOS() {
  const userAgent = navigator.userAgent.toLowerCase();

  // Check for explicit iOS devices
  const isAppleDevice = /ipad|iphone|ipod/.test(userAgent);

  // Check for iPad on iOS 13+ (which reports as Mac)
  const isPadOnIOS13 =
    userAgent.includes('mac') &&
    navigator.maxTouchPoints > 1 &&
    !userAgent.includes('windows') &&
    !userAgent.includes('android');

  return isAppleDevice || isPadOnIOS13;
}

// Check if app is running in standalone mode
export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator.standalone !== undefined && window.navigator.standalone)
  );
}
